#import "../fragments/ctct-contact.graphql"

mutation SyncCtctEntity($entityId: ID!) {
    constantContactSyncEntity(input: {id: $entityId}) {
        entity {
            ctctContacts {
                ...CtCtContact
            }
        }
    }
}
